var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardShippingGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#EBF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.762 60H55.5C57.887 60 60.1762 59.0518 61.864 57.364C63.5518 55.6761 64.5 53.3869 64.5 51V42H67.5C68.2957 42 69.0587 41.6839 69.6213 41.1213C70.184 40.5587 70.5 39.7956 70.5 39V33C70.5 31.4087 69.8679 29.8826 68.7427 28.7574C67.6174 27.6321 66.0913 27 64.5 27H57C55.6998 27.3752 54.5572 28.1638 53.7452 29.2464C52.9332 30.329 52.4961 31.6467 52.5 33V36",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.89 42.302C47.2296 40.1601 43.9155 38.9947 40.5 39C32.216 39 28.5 45.716 28.5 54V57",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 57.0008C27.7044 57.0008 26.9413 57.3169 26.3787 57.8795C25.8161 58.4421 25.5 59.2051 25.5 60.0008C25.5 60.7964 25.8161 61.5595 26.3787 62.1221C26.9413 62.6847 27.7044 63.0008 28.5 63.0008H48C54 63.0008 55.5 57.0008 55.5 54.0008C55.5032 51.7556 55.0016 49.5383 54.0322 47.5131C53.0629 45.4879 51.6507 43.7066 49.9 42.3008C50.6325 44.1116 51.0061 46.0475 51 48.0008C51 51.0008 49.5 57.0008 43.5 57.0008H28.5Z",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0353 40.4922L30.5293 56.9982",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.502 40L49.356 53.854",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2715 45.2734L41.9975 56.9994",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5012 63V66C37.5012 66.7956 37.1851 67.5587 36.6225 68.1213C36.0599 68.6839 35.2968 69 34.5012 69H29.7772C29.4663 69 29.1631 68.9033 28.9095 68.7234C28.6559 68.5436 28.4645 68.2893 28.3617 67.9959C28.2589 67.7025 28.2498 67.3844 28.3357 67.0856C28.4216 66.7868 28.5983 66.522 28.8412 66.328L33.0012 63H37.5012Z",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 63.0016V66.0016C46.5 66.7972 46.8161 67.5603 47.3787 68.1229C47.9413 68.6855 48.7044 69.0016 49.5 69.0016H54.224C54.5349 69.0015 54.8381 68.9049 55.0917 68.725C55.3453 68.5451 55.5367 68.2909 55.6395 67.9975C55.7423 67.704 55.7513 67.3859 55.6654 67.0871C55.5795 66.7883 55.4029 66.5236 55.16 66.3296L50.506 62.6016",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 32.25C61.6989 32.25 61.8897 32.329 62.0303 32.4697C62.171 32.6103 62.25 32.8011 62.25 33",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 33C60.75 32.8011 60.829 32.6103 60.9697 32.4697C61.1103 32.329 61.3011 32.25 61.5 32.25",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 33.75C61.3011 33.75 61.1103 33.671 60.9697 33.5303C60.829 33.3897 60.75 33.1989 60.75 33",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.25 33C62.25 33.1989 62.171 33.3897 62.0303 33.5303C61.8897 33.671 61.6989 33.75 61.5 33.75",
    stroke: "#808080",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardShippingGraphic);
export default __webpack_public_path__ + "static/media/standard-shipping-graphic.2a02a2c0a19c0ea58f61aa1b592c41d5.svg";
export { ForwardRef as ReactComponent };